import './user.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from 'antd';
import { AuthActions as actions } from '../../../actions';
import { RoleIds } from '../../../models';

function LoginButton(props) {
    return (
        <NavLink to="/auth/login">
            <Button className="login-button" type="primary" ghost {...props}>
                Login
            </Button>
        </NavLink>
    );
}

export function UserMenu({ user, logout, loggedIn }) {
    const [submenuVisible, setSubmenuVisible] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const toggleSubmenu = () => {
        setSubmenuVisible(!submenuVisible);
    };

    const handleLogout = async () => {
        setIsLoggingOut(true);
        await logout();
        setIsLoggingOut(false);
    };

    let { companyName } = user;
    if (!companyName) companyName = 'Unknown';

    if (!loggedIn) {
        return <LoginButton />;
    }

    const userAvatar = companyName[0];

    const items = [
        {
            key: 'divider',
        },
        {
            key: 'logout',
            to: '#',
            label: 'Logout',
            onClick: handleLogout,
            disabled: isLoggingOut,
        },
    ];

    if (user.roleId === RoleIds.ADMIN) {
        items.unshift({
            key: 'admincp',
            label: 'User Management',
            to: '/admincp',
            onClick: toggleSubmenu,
        });
    }

    if (user.roleId !== RoleIds.ADMIN) {
        const isProClient = user.roleId === RoleIds.PROCLIENT;
        items.unshift({
            key: isProClient ? 'inventory' : 'proClientAccessInformation',
            label: 'Taxidermy STARS',
            to: isProClient ? '/inventory' : '/proClientAccessInformation',
            onClick: toggleSubmenu,
        });

        items.unshift({
            key: 'orders',
            label: 'My Orders',
            to: '/orders',
            onClick: toggleSubmenu,
        });

        items.unshift({
            key: 'profile',
            label: 'My Profile',
            to: '/profile',
            onClick: toggleSubmenu,
        });
    }

    return (
        <Button
            id="profile"
            className={`profile with-submenu ${submenuVisible ? 'show-modal' : ''}`}
            onClick={toggleSubmenu}
        >
            <div className="avatar">{userAvatar}</div>
            <div className="name add-arrow">{companyName}</div>
            <div className="submenu right modal">
                {items.map(item => {
                    if (item.key === 'divider') return <hr key={item.key} />;

                    return (
                        <NavLink
                            key={item.key}
                            to={item.to}
                            onClick={item.onClick}
                            activeClassName={item.disabled ? 'disabled' : 'active'}
                            disabled={item.disabled}
                        >
                            <div>{item.label}</div>
                        </NavLink>
                    );
                })}
            </div>
        </Button>
    );
}
// }

UserMenu.propTypes = {
    user: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ authentication: { user, loggedIn } }) => ({ user, loggedIn });

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(actions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
